export const environment = {
    production: false,
    apiURL: 'https://apigatewaydemo.cunamutual.com/cmfg/demo-int/',
    apiManagerURL: 'https://demo-apimanager.trustage.com/',
    clientID: '29f455c3-c46b-4b3c-9888-184bf6aa5aea',
};